import request from '@/utils/request'

// 查询列表
export function apiTSysInventoryOrganizationList (query) {
  return request({
    url: '/mdm/tSysInventoryOrganization/list',
    method: 'get',
    params: query
  })
}

// 日历名称
export function apiRoutingCalendarPullDownList (query) {
  return request({
    url: '/bom/routingCalendar/pullDownList',
    method: 'get',
    params: query
  })
}

// 修改
export function apiTSysInventoryOrganizationUpdate (data) {
  return request({
    url: '/mdm/tSysInventoryOrganization',
    method: 'put',
    data: data
  })
}
